import React, { createContext, useReducer, ReactNode } from "react";
import { State, Action, ActionTypes } from "./ActionTypes";

export const StoreContext = createContext<any>(null);

const queryParams = new URLSearchParams(window.location.search);
let pageLook = queryParams.get('page_look');
let state = queryParams.get('state');

if(state){
    state = decodeURIComponent(state);
}

if(state){
    pageLook = state.slice(state.indexOf(":") + 1);
}

const initialState: State = {
    page_look:                              pageLook ? pageLook : "default",
    page_loading:                           false,
    loading:                                true,
    error:                                  false,
    popup:                                  "",
    banner:                                 "COOKIE_BANNER",
    tealium:                                false,
    tealiumVisitorId:                       "",
    tealiumVisitorIdGroup:                  "",
    tealiumVisitorIdMarket:                 "",
    data:                                   {},
    tnc:                                    {},
    pp:                                     {},
    functional_cookies_consent_granted:     false,
    performance_cookies_consent_granted:    false,
    marketing_cookies_consent_granted:      false,
    consent_timestamp:                      ""
};

const initialReducer = (state: State, action: Action): State => {
    switch (action.type) {
        case ActionTypes.PAGE_LOADING:
            return {
                ...state,
                page_loading: action.loading !== true ? false : true,
                loading: false
            };
        case ActionTypes.LOADING:
            return {
                ...state,
                page_loading: false,
                loading: action.loading !== true ? false : true
            };
        case ActionTypes.RESPONSE:
            return {
                ...state,
                page_loading: false,
                loading: false,
                data: action.data!
            };
        case ActionTypes.ERROR:
            return {
                ...state,
                loading: false,
                error: true
            };
        case ActionTypes.POPUP:
            return {
                ...state,
                popup: action.popup!,
                banner: ""
            };
        case ActionTypes.BANNER:
            return {
                ...state,
                banner: action.banner!,
            };
        case ActionTypes.TERMS_AND_CONDITIONS:
            return {
                ...state,
                tnc: action.tnc,
            };
        case ActionTypes.PRIVACY_POLICY:
            return {
                ...state,
                pp: action.pp,
            };

        case ActionTypes.TEALIUM:
            return {
                ...state,
                tealium: action.tealium,
                tealiumVisitorId: action.tealiumVisitorId ? action.tealiumVisitorId : "N/A",
                tealiumVisitorIdGroup: action.tealiumVisitorIdGroup ? action.tealiumVisitorIdGroup : "N/A",
                tealiumVisitorIdMarket: action.tealiumVisitorIdMarket ? action.tealiumVisitorIdMarket : "N/A"
            };
        case ActionTypes.CONSENT:
            return {
                ...state,
                functional_cookies_consent_granted: action.functional_cookies_consent_granted,
                performance_cookies_consent_granted: action.performance_cookies_consent_granted,
                marketing_cookies_consent_granted: action.marketing_cookies_consent_granted,
                consent_timestamp: action.consent_timestamp
            };
        
        default:
            return state;
    }
};

interface StateProviderProps {
    children: ReactNode;
}

export const StateProvider: React.FC<StateProviderProps> = ({ children }) => {
    const [state, dispatch] = useReducer(initialReducer, initialState);
    const value = { state, dispatch };
  
    return (
      <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
    );
  };
